// extracted by mini-css-extract-plugin
export default {"header":"PdfEditorOverlayController_header__6ya8Z","goBack":"PdfEditorOverlayController_goBack__2eQ3y"};